"use client";

import StyledComponentsRegistry from "./registry";
import { ThemeProvider } from "styled-components";
import theme from "@/themes/velys-theme";

export function ThemeWrapper({ children }: { children: React.ReactNode }) {
  return (
    <StyledComponentsRegistry>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </StyledComponentsRegistry>
  );
}
